import {pushNotification} from '@malt/joy-entrypoint/src/js/notification';

const WISHLIST_BASE_URI = '/api/profile/wishlists';

Hop.wishlists = {};

/* Wishlist creation function , opts are :
{
  wishlistName : string
  profileIds : [],
  callback : function (newWishlist)
}
*/

function failCallback(jqXHR, textStatus, errorThrown) {
    if ((jqXHR && jqXHR.responseText) || errorThrown) {
        pushNotification((jqXHR && jqXHR.responseText) || errorThrown, {level: 'error'});
    }
}

Hop.wishlists.createWishlist = function (opts) {
    const profilesData = !opts.profileIds ? [] : opts.profileIds;

    const data = {
        name: opts.wishlistName,
        sharedWithinCompany: opts.sharedWithinCompany,
        profiles: profilesData,
    };

    $.ajax({
        type: 'POST',
        url: WISHLIST_BASE_URI,
        data: JSON.stringify(data),
        contentType: 'application/json',
    })
        .done((response) => {
            if (opts.callback && typeof opts.callback === 'function') {
                opts.callback(response);
            }
        })
        .fail(failCallback);
};

/* Wishlist removal function , opts are :
{
  wishlistId : string,
  callback : function (optionnal)
}
*/
Hop.wishlists.deleteWishlist = function (opts) {
    $.ajax({
        type: 'DELETE',
        url: WISHLIST_BASE_URI + '/' + opts.wishlistId,
    })
        .done((response) => {
            if (opts.callback && typeof opts.callback === 'function') {
                opts.callback(response);
            }
        })
        .fail(failCallback);
};

/* Wishlist profile toggle function, opts are :
{
  wishlistId : string,
  profileId : string,
  callback : function (optionnal)
}
*/
Hop.wishlists.toggleProfile = function (opts) {
    const type = opts.action === 'add' ? 'POST' : 'DELETE';

    $.ajax({
        type: type,
        url: WISHLIST_BASE_URI + '/' + opts.wishlistId + '/profiles/' + opts.profileId + '?source=' + opts.source,
    })
        .done((...args) => {
            opts.callback(args);
        })
        .fail(failCallback);
};

Hop.wishlists.getAllWishlistsOfCurrentUser = function (callback) {
    $.ajax({
        type: 'GET',
        url: WISHLIST_BASE_URI,
    })
        .done((data) => {
            if (callback && typeof callback === 'function') {
                callback(data);
            }
        })
        .fail(failCallback);
};

Hop.wishlists.checkWishlistedItems = function (profileIds, callback) {
    $.ajax({
        url: WISHLIST_BASE_URI + '/check',
        type: 'POST',
        data: JSON.stringify(profileIds),
        contentType: 'application/json',
    }).done((data) => {
        data.forEach(callback);
    });
};

Hop.wishlists.changeWishlistName = function (opts) {
    $.ajax({
        url: '/wishlists/' + opts.wishlistId + '/name?name=' + opts.wishlistNewName,
        type: 'PUT',
    })
        .done(() => {
            opts.callback();
        })
        .fail(failCallback);
};
